import styled from 'styled-components';

export const StyledMyIssue = styled.div``;
